// removed by extract-text-webpack-plugin
module.exports = {"LegendHeader":"_31MVp","LegendItem":"_2BWCv","Legend":"_3ewhb","none":"mH9tv","vertical":"_1Xgds","horizontal":"_2_WUZ"};


//////////////////
// WEBPACK FOOTER
// ./visualizations/components/Legend.css
// module id = 183
// module chunks = 3 4 5